import { HyperLink } from '../../../Common/Form'
import styles from './ActionLink.css'

const ActionLink = props => {
  const {
    target = '_blank',
    targetURL,
    children,
    ...otherProps
  } = props

  return (
    <HyperLink
      className={styles.actionLink}
      target={target}
      href={targetURL}
      {...otherProps}
    >
      {children}
    </HyperLink>
  )
}

export default ActionLink
